import Vue from "vue";
import { Module } from "vuex";

type ToastStyle = "success" | "danger" | "warning" | "info";

export interface ToastContent {
  date: Date;
  title: string;
  body: string;
  style: ToastStyle;
}

export interface ToastContents {
  [id: string]: {
    show: boolean;
    content: ToastContent;
  };
}

export interface ModuleState {
  toasts: ToastContents;
}

export interface ShowMutation {
  id: string;
  content: ToastContent;
}

export interface HideMutation {
  id: string;
}

export interface DisposeMutation {
  id: string;
}

const module: Module<ModuleState, {}> = {
  namespaced: true,
  state: {
    toasts: {}
  },
  mutations: {
    show(state, { id, content }: ShowMutation) {
      Vue.set(state.toasts, id, { show: true, content });
    },
    hide(state, { id }: HideMutation) {
      if (id in state.toasts) {
        state.toasts[id].show = false;
      }
    },
    dispose(state, { id }: DisposeMutation) {
      Vue.delete(state.toasts, id);
    }
  }
};

export default module;
